import api from './api';

const adminService = {
  getUsers: (page = 1, role = '', status = '') =>
    api.get('/admin/users', { params: { page, role, status } }).then((r) => r.data),

  createUser: (data) =>
    api.post('/admin/users', data).then((r) => r.data),

  updateUserStatus: (userId, isActive) =>
    api.patch(`/admin/users/${userId}/status`, { isActive }).then((r) => r.data),

  verifyUserEmail: (userId) =>
    api.post(`/admin/users/${userId}/verify-email`).then((r) => r.data),

  getPendingVenues: () =>
    api.get('/admin/venues/pending').then((r) => r.data),

  getVenuePartnerApplications: (status = 'pending') =>
    api.get('/admin/venue-partner-applications', { params: { status } }).then((r) => r.data),

  approveVenuePartnerApplication: (userId) =>
    api.post(`/admin/venue-partner-applications/${userId}/approve`).then((r) => r.data),

  declineVenuePartnerApplication: (userId) =>
    api.post(`/admin/venue-partner-applications/${userId}/decline`).then((r) => r.data),

  getOpenPlayOrganizerApplications: (status = 'pending') =>
    api.get('/admin/open-play-organizer-applications', { params: { status } }).then((r) => r.data),

  approveOpenPlayOrganizerApplication: (userId) =>
    api.post(`/admin/open-play-organizer-applications/${userId}/approve`).then((r) => r.data),

  rejectOpenPlayOrganizerApplication: (userId, note) =>
    api.post(`/admin/open-play-organizer-applications/${userId}/reject`, { note }).then((r) => r.data),

  getOpenPlayOrganizerSessions: (userId) =>
    api.get(`/admin/open-play-organizers/${userId}/sessions`).then((r) => r.data),

  revokeOpenPlayOrganizerAccess: (userId, note = '') =>
    api.post(`/admin/open-play-organizers/${userId}/revoke`, { note }).then((r) => r.data),

  getVenues: (status = '') =>
    api.get('/admin/venues', { params: { status } }).then((r) => r.data),

  approveVenue: (venueId) =>
    api.post(`/venues/${venueId}/approve`).then((r) => r.data),

  suspendVenue: (venueId) =>
    api.post(`/venues/${venueId}/suspend`).then((r) => r.data),

  getOpenPlays: () =>
    api.get('/openplays', { params: { status: 'all' } }).then((r) => r.data),

  getOpenPlay: (openPlayId) =>
    api.get(`/openplays/${openPlayId}`).then((r) => r.data),

  createOpenPlay: (data) =>
    api.post('/openplays', data).then((r) => r.data),

  updateOpenPlay: (openPlayId, data) =>
    api.put(`/openplays/${openPlayId}`, data).then((r) => r.data),

  cancelOpenPlay: (openPlayId) =>
    api.delete(`/openplays/${openPlayId}`).then((r) => r.data),

  completeOpenPlay: (openPlayId) =>
    api.post(`/openplays/${openPlayId}/complete`).then((r) => r.data),

  removeOpenPlayPlayer: (openPlayId, playerId) =>
    api.delete(`/openplays/${openPlayId}/players/${playerId}`).then((r) => r.data),

  setCommissionRate: (rule, effectiveDate) =>
    api.post('/admin/commission', { ...rule, effectiveDate }).then((r) => r.data),

  getCommissionHistory: (venueId = '') =>
    api.get('/admin/commission', { params: venueId ? { venueId } : {} }).then((r) => r.data),

  useGlobalCommissionRates: (venueId) =>
    api.delete(`/admin/commission/venue/${venueId}`).then((r) => r.data),

  getAnalytics: (startDate, endDate) =>
    api.get('/admin/analytics', { params: { startDate, endDate } }).then((r) => r.data),

  getReports: (startDate, endDate, paymentWindow) =>
    api.get('/admin/reports', { params: {
      startDate,
      endDate,
      ...(paymentWindow ? {
        paymentStartDateTime: paymentWindow.start,
        paymentEndDateTime: paymentWindow.end,
      } : {}),
    } }).then((r) => r.data),

  getBookingDetailsFilterOptions: () =>
    api.get('/reports/booking-details/filter-options').then((r) => r.data),

  getBookingDetailsReport: (params) =>
    api.get('/reports/booking-details', { params }).then((r) => r.data),

  recoverPaidCancelledBooking: (bookingId, sendConfirmationEmail = true) =>
    api.post(`/payments/admin/bookings/${bookingId}/recover-paid`, null, {
      params: { sendConfirmationEmail },
    }).then((r) => r.data),

  getPaymentReconciliation: (params) =>
    api.get('/admin/payment-reconciliation', { params }).then((r) => r.data),

  runPaymentReconciliation: (lookbackHours = 48) =>
    api.post('/admin/payment-reconciliation/run', null, { params: { lookbackHours } }).then((r) => r.data),

  resolvePaymentReconciliationException: (id, data) =>
    api.patch(`/admin/payment-reconciliation/exceptions/${id}/resolve`, data).then((r) => r.data),

  exportPaymentReconciliation: (params) =>
    api.get('/admin/payment-reconciliation/export', { params, responseType: 'blob' }).then((r) => r.data),

  fetchClosingPositionBalances: () =>
    api.post('/admin/reports/closing-position/balances', null, { timeout: 60000 }).then((r) => r.data),

  generateClosingPosition: (data) =>
    api.post('/admin/reports/closing-position', data).then((r) => r.data),

  getDashboardStats: () =>
    api.get('/admin/dashboard').then((r) => r.data),

  getPayouts: (page = 1, status = '', pageSize = 20) =>
    api.get('/admin/payouts', { params: { page, status, pageSize } }).then((r) => r.data),

  getPayoutBookings: (payoutId) =>
    api.get(`/admin/payouts/${payoutId}/bookings`).then((r) => r.data),

  getEligiblePayouts: () =>
    api.get('/admin/payouts/eligible').then((r) => r.data),

  getCancelledPayoutEarnings: () =>
    api.get('/admin/payouts/cancelled-earnings').then((r) => r.data),

  addCancelledPayoutAdjustment: (payoutId, paymentId, amount, reason) =>
    api.post(`/admin/payouts/${payoutId}/adjustments`, { paymentId, amount, reason }).then((r) => r.data),

  voidCancelledPayoutAdjustment: (payoutId, adjustmentId) =>
    api.post(`/admin/payouts/${payoutId}/adjustments/${adjustmentId}/void`).then((r) => r.data),

  lookupPayoutHoldPayment: (payMongoPaymentId) =>
    api.get('/admin/payout-holds/lookup', { params: { payMongoPaymentId } }).then((r) => r.data),

  getPayoutHolds: () =>
    api.get('/admin/payout-holds').then((r) => r.data),

  createPayoutHold: (payMongoPaymentId, reason, hideFromOwnerReports = false) =>
    api.post('/admin/payout-holds', { payMongoPaymentId, reason, hideFromOwnerReports }).then((r) => r.data),

  releasePayoutHold: (holdId) =>
    api.post(`/admin/payout-holds/${holdId}/release`).then((r) => r.data),

  getPayMongoPayoutImports: () =>
    api.get('/admin/paymongo-payout-imports').then((r) => r.data),

  getPayMongoPayoutImport: (importId) =>
    api.get(`/admin/paymongo-payout-imports/${importId}`).then((r) => r.data),

  previewPayMongoPayoutImport: (file, payoutReference = '') => {
    const form = new FormData();
    form.append('file', file);
    if (payoutReference.trim()) form.append('payoutReference', payoutReference.trim());
    return api.post('/admin/paymongo-payout-imports/preview', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },

  confirmPayMongoPayoutImport: (importId, payoutReference = '') =>
    api.post(`/admin/paymongo-payout-imports/${importId}/confirm`, { payoutReference }).then((r) => r.data),

  deletePayMongoPayoutImport: (importId) =>
    api.delete(`/admin/paymongo-payout-imports/${importId}`),

  createPayout: (ownerId, isAdvance = false) =>
    api.post('/admin/payouts', { ownerId, isAdvance }).then((r) => r.data),

  requestPayoutTransferCode: (payoutId) =>
    api.post(`/admin/payouts/${payoutId}/verification-code`).then((r) => r.data),

  approvePayout: (payoutId, code, manualTransfer = false) =>
    api.post(`/admin/payouts/${payoutId}/approve`, { code, manualTransfer }).then((r) => r.data),

  rejectPayout: (payoutId, reason) =>
    api.post(`/admin/payouts/${payoutId}/reject`, { reason }).then((r) => r.data),

  releasePayout: (payoutId, code) =>
    api.post(`/admin/payouts/${payoutId}/release`, { code }).then((r) => r.data),

  recordManualPayout: (payoutId, data) =>
    api.post(`/admin/payouts/${payoutId}/record-manual-transfer`, data).then((r) => r.data),

  markPayoutSettlementRecovered: (payoutId) =>
    api.post(`/admin/payouts/${payoutId}/mark-settlement-recovered`).then((r) => r.data),

  getSettings: () => api.get('/admin/settings').then((r) => r.data),

  updateSettings: (settings) =>
    api.put('/admin/settings', settings).then((r) => r.data),

  changePassword: (currentPassword, newPassword) =>
    api.put('/admin/password', { currentPassword, newPassword }).then((r) => r.data),
};

export default adminService;
